import { z } from "zod";
import { machineStatusSchema } from "@packsize/schemas/machines";

import { machineSchema } from "./machine";
import { PORT_MAX, PORT_MIN } from "./constants";

export const x6MachineRequestSchema = z.object({
	alias: z.string(),
	description: z.string().optional(),
	ipOrDnsName: z.string().optional(),
	port: z.number().min(PORT_MIN).max(PORT_MAX).optional(),
});

export const x6MachineSchema = machineSchema.extend({
	// sufficient to extend base machineSchema for now
});

export type X6Machine = z.infer<typeof x6MachineSchema>;
export type X6MachineRequest = z.infer<typeof x6MachineRequestSchema>;

const zFoldSchema = z.object({
	id: z.string(),
	alias: z.string(),
	width: z.number(),
	thickness: z.number(),
	brand: z.number(),
});

const trackConfigurationSchema = z.object({
	trackNumber: z.number(),
	loadedZFold: zFoldSchema.optional(),
});

const uiTrackConfigurationSchema = trackConfigurationSchema.extend({
	configuredTrackWidth: z.number().optional().default(0),
});

export const uiChangeZFoldDataSchema = z.object({
	machineId: z.string(),
	machineAlias: z.string(),
	machineStatus: machineStatusSchema,
	trackConfigurations: z.array(uiTrackConfigurationSchema),
});

export const x6TrackConfigurationSchema = z.array(trackConfigurationSchema);

export type ZFold = z.infer<typeof zFoldSchema>;
export type TrackConfiguration = z.infer<typeof trackConfigurationSchema>;
export type UiTrackConfiguration = z.infer<typeof uiTrackConfigurationSchema>;
export type UiChangeZFoldData = z.infer<typeof uiChangeZFoldDataSchema>;
